import React from "react";
import styled from "@emotion/styled";
import LabelWithInput from "@components/input/LabelWithInput";
import CheckBoxInput from "@components/input/CheckBoxInput";
import { useFormContext } from "react-hook-form";
import BasicButton from "@components/button/BasicButton";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "1.4rem",
  height: "88vh",
});

const NavigateButton = styled.button(({ theme }) => ({
  color: theme.color.gray,
  textDecoration: "underline",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  bottom: 70,
  width: "100%",
}));

const ButtonWrapper = styled.div({
  width: "100%",
  position: "absolute",
  bottom: 0,
  left: 0,
});

const RegisterProductStepFour = () => {
  const { watch, setValue } = useFormContext();

  const terms = watch("terms");
  const { t } = useTranslation();

  const handleChange = () => {
    setValue("terms", !terms);
  };

  const handleNavigate = () => {
    window.open(
      "https://owlsociety.notion.site/Terms-of-Use-f730e5a7ab0f4494b5bfc6b7322e8e56",
      "_blank",
    );
  };

  return (
    <Container>
      <LabelWithInput label="샤카라카 이용약관 동의 타이틀" required>
        <CheckBoxInput
          label="샤카라카 이용약관 동의"
          checked={terms}
          onClick={handleChange}
        />
      </LabelWithInput>

      <NavigateButton onClick={handleNavigate} type="button">
        {t("이용약관 보러가기")}
      </NavigateButton>

      <ButtonWrapper>
        <BasicButton
          title="상품 등록하기"
          type="submit"
          height="5.2rem"
          width="100%"
          padding="1.6rem 1.2rem"
          disabled={watch("terms") === false}
        />
      </ButtonWrapper>
    </Container>
  );
};

export default RegisterProductStepFour;
